module.exports = __webpack_public_path__ + "assets/img/driver-btn-8ab3dad4.png";